<template>
    <div id="app" align="center">
        <div id="about-container" class="py-5 fadeInUp" v-html="getAboutContent"></div>
    </div>
</template>

<script>
import marked from 'marked';

export default {
    name: "About",
    components: {
    },
    data: () => {
        return {
            aboutContent: '',
            tagsToAnimate: ['h1', 'h2', 'p']
        }
    },
    methods: {
        renderMd() {
            /**
             * For the about page the text will be present in the
             * assets/about.md file
             */
            this.$http.get("./assets/about.md")
                .then(response => {
                    this.aboutContent = marked(response.body);
                })
        },
        addAnimationClass() {
            // Add a data-aos tags to all the supported tags.
            document.getElementById("about-container").getElementsByTagName("*").forEach((el, index) => {
                if (this.tagsToAnimate.includes(el.tagName.toLowerCase()))
                    el.classList.add('fadeInUp');
                    el.style.animationDelay = `${0.5 + index * 0.1}s`
            });
        }
    },
    computed: {
        getAboutContent() {
            return this.aboutContent;
        },
    },
    mounted() {
        this.renderMd();
    },
    updated() {
        this.addAnimationClass();
    }
}
</script>

<style lang="scss">
    #app {

        #about-container {
            width: 40%;
            text-align: left;

            @media only screen and (max-width: 950px) {
                width: 65%;
            }
            @media only screen and (max-width: 468px) {
                width: 95%;
            }

            h1 {
                margin: 2rem 0;
            }

            h2 {
                margin: 1.5rem 0;
            }

            p {
                font-size: 18px;
                color: #512DA8;
                font-weight: 500;

                b {
                    font-weight: 600;
                }
            }

            a {
                color: #000;

                &:hover {
                    color: #121212;
                }
            }
        }
    }
</style>